// Shared sort helpers for contacts and customers panels in the Edit Rule view.

export const SORT_CYCLE = [null, "asc", "desc"];

export const nextSortDirection = (current) => {
  const idx = SORT_CYCLE.indexOf(current);
  return SORT_CYCLE[(idx + 1) % SORT_CYCLE.length];
};

export const getContactSortField = (period) =>
  period === "30d" ? "rfq_count_30d" : "rfq_count_7d";

export const CUSTOMER_SORT_FIELD = "rfq_count_30d";
